import React, { useState, useEffect } from "react";
import AppModal from "components/ui/AppModal/AppModal";

const INITIAL = {
  open: false,
  variant: "info",
  title: "",
  message: "",
  confirmText: "OK",
  cancelText: null,
  redirectOnConfirm: null,
};

/**
 * GlobalModal — escuta o evento "app:global-modal" e exibe AppModal.
 * Deve ser montado uma única vez, dentro de <BrowserRouter> no App.jsx.
 */
const GlobalModal = () => {
  const [modal, setModal] = useState(INITIAL);

  useEffect(() => {
    const handler = (e) => {
      setModal({ ...INITIAL, ...e.detail, open: true });
    };
    window.addEventListener("app:global-modal", handler);
    return () => window.removeEventListener("app:global-modal", handler);
  }, []);

  const closeModal = () => setModal((m) => ({ ...m, open: false }));

  const handleConfirm = () => {
    closeModal();
    if (modal.redirectOnConfirm) {
      window.location.href = modal.redirectOnConfirm;
    }
  };

  return (
    <AppModal
      isOpen={modal.open}
      onClose={closeModal}
      allowOutsideClick={true}
      variant={modal.variant}
      title={modal.title}
      message={modal.message}
      confirmText={modal.confirmText}
      onConfirm={handleConfirm}
      cancelText={modal.cancelText}
      onCancel={closeModal}
    />
  );
};

export default GlobalModal;
